import React from "react";
import Header from "../../Components/Header/index"
import Footer from "../../Components/Footer/index"
import ContentSwitch from "./ContentSwitch/index"

export default class extends React.Component {
    constructor() {
        super();
        this.state = {
            ready: false,
        };
        this.setReady = this.setReady.bind(this);
    }

    setReady() {
        this.setState({ ready: true });
    }

    render() {

        const {setting} = this.props.route;

        const header = <Header setting={setting}/>;

        return (
            <div>
                {header}
                <ContentSwitch {...this.props} setReady={this.setReady} />
                {this.state.ready && <Footer setting={setting} />}
            </div>
        )
    }
}


